import styled from "styled-components";
import { theme } from "../../configuration";

const HelpArticleSidebarContainer = styled.div`
  display: none;
  
  @media (min-width: ${theme.pageWidthForSingleColumnHelpResults}) {
    display: block;
    float: left;
    min-width: 200px;
    max-width: 250px;
    padding-right: 25px;
    padding-top: 25px;
  }
`;

export default HelpArticleSidebarContainer;
